import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserEventOnDayPromptQueryVariables = Types.Exact<{
  input: Types.GetUserEventOnDayPromptInput;
}>;

export type GetUserEventOnDayPromptQuery = {
  __typename?: 'Query';
  getUserEventOnDayPrompt: {
    __typename?: 'GetUserEventOnDayPromptResponse';
    attendance?: boolean | null;
    gearConfirmation?: boolean | null;
    notRequiredOnSite?: boolean | null;
    onSiteArrival?: boolean | null;
    safetyBriefingAttendance?: boolean | null;
    safetyBriefingComplete?: boolean | null;
    uuid: string;
    onSiteArrivalUpdatedAt?: string | null;
    notRequiredOnSiteUpdatedAt?: string | null;
    gearConfirmationUpdatedAt?: string | null;
    attendanceUpdatedAt?: string | null;
    safetyBriefingAttendanceUpdatedAt?: string | null;
    safetyBriefingCompleteUpdatedAt?: string | null;
    attendanceDate?: string | null;
  };
};

export const GetUserEventOnDayPromptDocument = gql`
  query GetUserEventOnDayPrompt($input: GetUserEventOnDayPromptInput!) {
    getUserEventOnDayPrompt(input: $input) {
      attendance
      gearConfirmation
      notRequiredOnSite
      onSiteArrival
      safetyBriefingAttendance
      safetyBriefingComplete
      uuid
      onSiteArrivalUpdatedAt
      notRequiredOnSiteUpdatedAt
      gearConfirmationUpdatedAt
      attendanceUpdatedAt
      safetyBriefingAttendanceUpdatedAt
      safetyBriefingCompleteUpdatedAt
      attendanceDate
    }
  }
`;
export function useGetUserEventOnDayPromptQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserEventOnDayPromptQuery,
    GetUserEventOnDayPromptQueryVariables
  > &
    (
      | { variables: GetUserEventOnDayPromptQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserEventOnDayPromptQuery,
    GetUserEventOnDayPromptQueryVariables
  >(GetUserEventOnDayPromptDocument, options);
}
export function useGetUserEventOnDayPromptLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserEventOnDayPromptQuery,
    GetUserEventOnDayPromptQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserEventOnDayPromptQuery,
    GetUserEventOnDayPromptQueryVariables
  >(GetUserEventOnDayPromptDocument, options);
}
export function useGetUserEventOnDayPromptSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUserEventOnDayPromptQuery,
        GetUserEventOnDayPromptQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUserEventOnDayPromptQuery,
    GetUserEventOnDayPromptQueryVariables
  >(GetUserEventOnDayPromptDocument, options);
}
export type GetUserEventOnDayPromptQueryHookResult = ReturnType<
  typeof useGetUserEventOnDayPromptQuery
>;
export type GetUserEventOnDayPromptLazyQueryHookResult = ReturnType<
  typeof useGetUserEventOnDayPromptLazyQuery
>;
export type GetUserEventOnDayPromptSuspenseQueryHookResult = ReturnType<
  typeof useGetUserEventOnDayPromptSuspenseQuery
>;
export type GetUserEventOnDayPromptQueryResult = Apollo.QueryResult<
  GetUserEventOnDayPromptQuery,
  GetUserEventOnDayPromptQueryVariables
>;
export function refetchGetUserEventOnDayPromptQuery(
  variables: GetUserEventOnDayPromptQueryVariables,
) {
  return { query: GetUserEventOnDayPromptDocument, variables: variables };
}
